import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Rapidfreeservices() {
  return (
    <section
      className="rapid_free_services p-100 nlp_transform"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>Flexible Cooperation Models for Vendor Portal Development</h2>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              As a leading vendor portal development company, our cooperation
              models are designed to fit your vendor portal development
              objectives. Enjoy the latest features, options, and solutions and
              select from various flexible solutions that correspond to both
              full-scale and individual project demands.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                01
              </div>
              <div className="rapid_content">
                <h5>End-to-End Vendor Portal Development Solutions</h5>
                <p>
                  We manage from creating the vendor portal right from the start
                  to the end. Beginning with precise area identification, we
                  create user-friendly interfaces and build the software with
                  appropriate testing. We work closely with your team and ensure
                  that our solution will easily interface with your existing
                  systems.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                02
              </div>
              <div className="rapid_content">
                <h5>Customized Vendor Portal Development</h5>
                <p>
                  We offer integrated vendor portal solutions, including the
                  selection of the platform, whether it is Dynamics 365,
                  Salesforce, or SharePoint, among others. Portal assessment,
                  designing, customization, implementation of third-party tools,
                  and portal migration to new platforms/versions are some of the
                  services offered for operational effectiveness.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                03
              </div>
              <div className="rapid_content">
                <h5>Vendor Portals Built to Your Specs</h5>
                <p>
                  Our team develops vendor portal solutions based purely on the
                  project specifications, ensuring that the functionality
                  provided is exactly what you need. We work with your team to
                  ensure that all of the portal's capabilities are tailored to
                  your specific business needs and that no parts are overlooked.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="rapid_box h-100">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                04
              </div>
              <div className="rapid_content">
                <h5>Modernizing Outdated Vendor Portals</h5>
                <p>
                  We upgrade your present vendor portal to improve essential
                  performance while also increasing compatibility with existing
                  systems. Our approach comprises moving your data to keep your
                  essential information while also improving the overall
                  efficiency of your original solution.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Rapidfreeservices;
